import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"

import Seo from "../components/seo"
import Link from "../components/Link"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import EnglishBreadcrumb from "../utils/EnglishBreadcrumb"
import { FormattedMessage } from "react-intl"
import { options, renderLinkedIn, renderTwitter } from "../utils/richtext"

export const query = graphql`
  query ($slug: String!) {
    contentfulCaseStudy(slug: { eq: $slug }) {
      title
      slug
      node_locale
      seoDescription
      heroImage {
        gatsbyImageData(width: 2048)
        title
        description
        height
        width
      }
      body {
        raw
        references {
          ... on ContentfulAsset {
            __typename
            file {
              url
              contentType
            }
            contentful_id
            title
            description
            gatsbyImageData(width: 400)
          }
          ... on ContentfulHighlight {
            __typename
            contentful_id
            title
            body {
              raw
            }
            source
          }
        }
      }
      contact {
        fullName
        photo {
          gatsbyImageData(width: 240)
          title
          description
        }
        email
        linkedIn
        twitter
        jobTitle
      }
    }
  }
`
const CasePost = props => {
  let metaImg = null
  let metaImgObj = null
  if (props.data.contentfulCaseStudy.heroImage !== null) {
    metaImg = getSrc(props.data.contentfulCaseStudy.heroImage)
    metaImgObj = {
      src: metaImg,
      width: props.data.contentfulCaseStudy.heroImage.width,
      height: props.data.contentfulCaseStudy.heroImage.height,
    }
  }
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace(/(.)*\//, "")
    .replace("-", " ")
    .replace(/\//g, "")

  //console.log(props.data.contentfulCaseStudy.body)

  return (
    <Layout location={props.location}>
      <Seo
        title={props.data.contentfulCaseStudy.title}
        description={props.data.contentfulCaseStudy.seoDescription}
        image={metaImgObj}
        pathname={"cases/" + props.data.contentfulCaseStudy.slug}
        lang={props.data.contentfulCaseStudy.node_locale}
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            {props.data.contentfulCaseStudy.node_locale === "en-US" ? (
              <EnglishBreadcrumb
                crumbs={crumbs}
                crumbSeparator=" / "
                crumbLabel={props.location.pathname}
              />
            ) : (
              <Breadcrumb
                crumbs={crumbs}
                crumbSeparator=" / "
                crumbLabel={customCrumbLabel}
              />
            )}
          </div>
        </div>
      </div>

      <div className="case-header">
        <div className="hero-image">
          {props.data.contentfulCaseStudy.heroImage && (
            <GatsbyImage
              className="featured"
              image={getImage(props.data.contentfulCaseStudy.heroImage)}
              alt={props.data.contentfulCaseStudy.title}
            />
          )}
        </div>
        <div className="case-title">
          <h1>{props.data.contentfulCaseStudy.title}</h1>
        </div>
      </div>
      <div className="wide-container">
        <div className="content_narrow">
          <div className="casepost">
            {props.data.contentfulCaseStudy.body &&
              renderRichText(props.data.contentfulCaseStudy.body, options)}
          </div>
          <div className="case-cta">
            <div className="case-cta-person">
              <div className="case-cta-photo">
                {props.data.contentfulCaseStudy.contact.photo && (
                  <GatsbyImage
                    className="case-cta-img"
                    image={getImage(
                      props.data.contentfulCaseStudy.contact.photo,
                    )}
                    alt={props.data.contentfulCaseStudy.contact.fullName}
                  />
                )}
              </div>
              <div className="case-cta-label">
                <div className="case-cta-label-name">
                  {props.data.contentfulCaseStudy.contact.fullName}
                </div>
                <div className="case-cta-label-jobtitle">
                  {props.data.contentfulCaseStudy.contact.jobTitle}
                </div>
              </div>
            </div>
            <div className="case-cta-description">
              <span className="case-cta-description-label">
                <h2>
                  <FormattedMessage id="know_more" />
                </h2>
              </span>
              <p>
                <FormattedMessage id="know_more_body1" />{" "}
                {props.data.contentfulCaseStudy.contact.fullName}
                {", "}
                <FormattedMessage id="know_more_body2" />
              </p>
              <p>
                Email:{" "}
                <Link
                  to={"mailto:" + props.data.contentfulCaseStudy.contact.email}
                >
                  {props.data.contentfulCaseStudy.contact.email}
                </Link>
              </p>
              <div className="social_icons">
                {props.data.contentfulCaseStudy.contact.instagram &&
                  renderLinkedIn(
                    props.data.contentfulCaseStudy.contact.linkedIn,
                  )}
                {props.data.contentfulCaseStudy.contact.instagram &&
                  renderTwitter(props.data.contentfulCaseStudy.contact.twitter)}
              </div>
            </div>
          </div>
          <Link to="/cases/" className="back_link">
            <FormattedMessage id="case_overview_link" />
          </Link>
          <div className="space-8" />
        </div>
      </div>
    </Layout>
  )
}

export default CasePost
